<form [formGroup]="taskEdit" class="">
  <div class="dialog-header-container">
    <!-- <div> -->
      <h1 mat-dialog-title class="pd-t-5px m-0" [ngStyle]="{'padding-left':'0px !important'}">Task Edit</h1>
    <!-- </div> -->
    <div>
        <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon" #tooltip="matTooltip"
        matTooltip="close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>
  </div>
  <mat-divider class = "mat-divider"></mat-divider>


      <div class="padding-clss">
        <div>
          <mat-label class="body-font-size">Title</mat-label>
          <div  [ngStyle]="{'outline':'1px'}" class="body-font-size taskTitles task-title-editor-wrapper" contenteditable="true" id = "taskValue">
            <app-adc-editor
                  class="task-adc-editor"
                  [content]="taskDetails.taskData.taskTitle"
                  [config]="quillConfig"
                  (editorReady)="onQuillReady($event)">
            </app-adc-editor>
          </div>
      </div>
      <mat-divider class = "mat-divider"></mat-divider>
      <div class="d-flex gap-3 align-items-center mt-3">
        <mat-form-field>
          <mat-label class="body-font-size">Assigned By</mat-label>
          <input matInput class="body-font-size" type="text" value = {{taskDetails.taskData.createdByName}} readonly/>
        </mat-form-field>
        <mat-form-field class="mar-r-10px mar-b-10px">
          <mat-label>Due Date</mat-label>
          <input formControlName="dueDate" (dateChange)="triggered()" class="due-Date editable-assignedTo" #input type="text" [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput >
          <mat-datepicker  (closed)="input.blur()" #picker></mat-datepicker>
        </mat-form-field>
      </div>
  <div id="editMeetingTask">
      
      <div id="taskEditBox" class="edit-contents d-flex flex-wrap" *ngFor="let a of taskDetails.taskData.actionItemOwner;let indexOfelement = index;">
        <mat-form-field class="mar-r-10px mar-b-10px">
          <mat-label class="body-font-size">
            Assigned To
          </mat-label>
          <input matInput (blur)="clearAttendee(indexOfelement,$event)" (focus)="reassignTask(a.fkSecUserOwner,$event.target,indexOfelement)" [disabled] = "a.ownerName != '' ? true : false" [attr.fkuserid]="a.fkSecUserOwner" (input) = "assignerNames($event)" type = "text" class="body-font-size Re_assignedToVal" value={{a.ownerName}}/>
        </mat-form-field>
        <mat-form-field class="mar-r-10px mar-b-10px" *ngIf = "a.ownerName != ''">
          <mat-label class="body-font-size">
            Re Assign
          </mat-label>
          <input (blur)="clearAttendee(indexOfelement,$event)" [attr.fkuserid]="a.fkSecUserOwner" [attr.agid]="taskDetails.taskData.agendaId"  [attr.minId]="taskDetails.taskData.taskId" [attr.taskId]="taskDetails.taskId" id="reAssign" class="bottom-border editable-reassignedTo " (focus)="reassignTask(a.fkSecUserOwner,$event.target,indexOfelement)" matInput type = "text" class="body-font-size Re_assignedToVal" />
        </mat-form-field>
        
        <mat-form-field class="mar-r-10px mar-b-10px">  
          <mat-label class="body-font-size">Status</mat-label>
          <mat-select disableOptionCentering panelClass="common-drop-down-class" class="body-font-size" [value]="a.fkCodelstStatus" (focus)="taskUser(a.fkSecUserOwner)" (selectionChange)="taskStatusUpdate($event)">
            <mat-option class="body-font-size"
            *ngFor="let l of taskStatusList" [value]="l.codeId">{{l.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button *ngIf = "indexOfelement == 0" mat-icon-button (click) = "AddOtherRow(indexOfelement)">
          <mat-icon>add</mat-icon>
        </button>
        <button *ngIf = "indexOfelement != 0" mat-icon-button (click) = "deleteRow(indexOfelement)">
          <mat-icon>delete</mat-icon>
        </button>
       
      </div>
     
      <mat-form-field class="text-area-container">
        <mat-label class="body-font-size">Remarks / Comments</mat-label>
        <textarea formControlName="noteDescription" matInput class="body-font-size text-area-fitter"></textarea>
      </mat-form-field>
      
    </div>
      </div>
  <div mat-dialog-actions class="button-actions-container">
    <button mat-button class="button-container primary" (click)=" taskDetails.taskData.actionItemOwner.length == 0 ? updateNewTaskDialog() : updateTaskDialog()">Update</button>
    <button mat-button mat-dialog-close class="button-container primary">Cancel</button>
  </div>
  </form>